/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteRequestExchange } from "./QuoteRequestExchange";
import {
  QuoteRequestExchangeFromJSON,
  QuoteRequestExchangeFromJSONTyped,
  QuoteRequestExchangeToJSON,
  QuoteRequestExchangeToJSONTyped,
} from "./QuoteRequestExchange";
import type { CarrierInvoiceLine } from "./CarrierInvoiceLine";
import {
  CarrierInvoiceLineFromJSON,
  CarrierInvoiceLineFromJSONTyped,
  CarrierInvoiceLineToJSON,
  CarrierInvoiceLineToJSONTyped,
} from "./CarrierInvoiceLine";
import type { CreditNoteLine } from "./CreditNoteLine";
import {
  CreditNoteLineFromJSON,
  CreditNoteLineFromJSONTyped,
  CreditNoteLineToJSON,
  CreditNoteLineToJSONTyped,
} from "./CreditNoteLine";
import type { AuditProblemSummary } from "./AuditProblemSummary";
import {
  AuditProblemSummaryFromJSON,
  AuditProblemSummaryFromJSONTyped,
  AuditProblemSummaryToJSON,
  AuditProblemSummaryToJSONTyped,
} from "./AuditProblemSummary";
import type { AuditChallenge } from "./AuditChallenge";
import {
  AuditChallengeFromJSON,
  AuditChallengeFromJSONTyped,
  AuditChallengeToJSON,
  AuditChallengeToJSONTyped,
} from "./AuditChallenge";

/**
 *
 * @export
 * @interface ShipmentInvoiceDetail
 */
export interface ShipmentInvoiceDetail {
  /**
   *
   * @type {boolean}
   * @memberof ShipmentInvoiceDetail
   */
  auditOpen: boolean;
  /**
   * True when we're waiting on the carrier's reply.
   * @type {boolean}
   * @memberof ShipmentInvoiceDetail
   */
  waitingOnCarrier?: boolean;
  /**
   *
   * @type {string}
   * @memberof ShipmentInvoiceDetail
   */
  auditOpenedAt?: string;
  /**
   * The carrier's own quote reference, where their system gave us one.
   * @type {string}
   * @memberof ShipmentInvoiceDetail
   */
  quoteReference?: string;
  /**
   * How the price was arrived at — carrier API, ratesheet, or manual.
   * @type {string}
   * @memberof ShipmentInvoiceDetail
   */
  quotingMethod?: string;
  /**
   * How the price was derived, in the carrier-safe wording we already
   * send them on the rate breakdown and in challenge emails. Never the
   * internal derivation.
   *
   * @type {string}
   * @memberof ShipmentInvoiceDetail
   */
  quoteExplanation?: string;
  /**
   * What we agreed to pay at booking, excluding tax.
   * @type {number}
   * @memberof ShipmentInvoiceDetail
   */
  quotedCad?: number;
  /**
   * Invoices minus credit notes to date, excluding tax.
   * @type {number}
   * @memberof ShipmentInvoiceDetail
   */
  invoicedCad?: number;
  /**
   * Invoiced minus quoted. Positive means the carrier billed above the quote.
   * @type {number}
   * @memberof ShipmentInvoiceDetail
   */
  differenceCad?: number;
  /**
   *
   * @type {Array<CarrierInvoiceLine>}
   * @memberof ShipmentInvoiceDetail
   */
  invoices: Array<CarrierInvoiceLine>;
  /**
   *
   * @type {Array<CreditNoteLine>}
   * @memberof ShipmentInvoiceDetail
   */
  creditNotes: Array<CreditNoteLine>;
  /**
   *
   * @type {Array<AuditProblemSummary>}
   * @memberof ShipmentInvoiceDetail
   */
  problems: Array<AuditProblemSummary>;
  /**
   * The challenges we've sent about this shipment, oldest first. Empty
   * for audits opened before we began recording them.
   *
   * @type {Array<AuditChallenge>}
   * @memberof ShipmentInvoiceDetail
   */
  challenges: Array<AuditChallenge>;
  /**
   *
   * @type {Array<QuoteRequestExchange>}
   * @memberof ShipmentInvoiceDetail
   */
  quoteRequests: Array<QuoteRequestExchange>;
}

/**
 * Check if a given object implements the ShipmentInvoiceDetail interface.
 */
export function instanceOfShipmentInvoiceDetail(
  value: object,
): value is ShipmentInvoiceDetail {
  if (!("auditOpen" in value) || value["auditOpen"] === undefined) return false;
  if (!("invoices" in value) || value["invoices"] === undefined) return false;
  if (!("creditNotes" in value) || value["creditNotes"] === undefined)
    return false;
  if (!("problems" in value) || value["problems"] === undefined) return false;
  if (!("challenges" in value) || value["challenges"] === undefined)
    return false;
  if (!("quoteRequests" in value) || value["quoteRequests"] === undefined)
    return false;
  return true;
}

export function ShipmentInvoiceDetailFromJSON(
  json: any,
): ShipmentInvoiceDetail {
  return ShipmentInvoiceDetailFromJSONTyped(json, false);
}

export function ShipmentInvoiceDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShipmentInvoiceDetail {
  if (json == null) {
    return json;
  }
  return {
    auditOpen: json["auditOpen"],
    waitingOnCarrier:
      json["waitingOnCarrier"] == null ? undefined : json["waitingOnCarrier"],
    auditOpenedAt:
      json["auditOpenedAt"] == null ? undefined : json["auditOpenedAt"],
    quoteReference:
      json["quoteReference"] == null ? undefined : json["quoteReference"],
    quotingMethod:
      json["quotingMethod"] == null ? undefined : json["quotingMethod"],
    quoteExplanation:
      json["quoteExplanation"] == null ? undefined : json["quoteExplanation"],
    quotedCad: json["quotedCad"] == null ? undefined : json["quotedCad"],
    invoicedCad: json["invoicedCad"] == null ? undefined : json["invoicedCad"],
    differenceCad:
      json["differenceCad"] == null ? undefined : json["differenceCad"],
    invoices: (json["invoices"] as Array<any>).map(CarrierInvoiceLineFromJSON),
    creditNotes: (json["creditNotes"] as Array<any>).map(
      CreditNoteLineFromJSON,
    ),
    problems: (json["problems"] as Array<any>).map(AuditProblemSummaryFromJSON),
    challenges: (json["challenges"] as Array<any>).map(AuditChallengeFromJSON),
    quoteRequests: (json["quoteRequests"] as Array<any>).map(
      QuoteRequestExchangeFromJSON,
    ),
  };
}

export function ShipmentInvoiceDetailToJSON(json: any): ShipmentInvoiceDetail {
  return ShipmentInvoiceDetailToJSONTyped(json, false);
}

export function ShipmentInvoiceDetailToJSONTyped(
  value?: ShipmentInvoiceDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    auditOpen: value["auditOpen"],
    waitingOnCarrier: value["waitingOnCarrier"],
    auditOpenedAt: value["auditOpenedAt"],
    quoteReference: value["quoteReference"],
    quotingMethod: value["quotingMethod"],
    quoteExplanation: value["quoteExplanation"],
    quotedCad: value["quotedCad"],
    invoicedCad: value["invoicedCad"],
    differenceCad: value["differenceCad"],
    invoices: (value["invoices"] as Array<any>).map(CarrierInvoiceLineToJSON),
    creditNotes: (value["creditNotes"] as Array<any>).map(CreditNoteLineToJSON),
    problems: (value["problems"] as Array<any>).map(AuditProblemSummaryToJSON),
    challenges: (value["challenges"] as Array<any>).map(AuditChallengeToJSON),
    quoteRequests: (value["quoteRequests"] as Array<any>).map(
      QuoteRequestExchangeToJSON,
    ),
  };
}
